$( document ).ready(function() {
// при завантаженні сторінки


$('a[href="#form"]').on('click',  function() {
  $('body').addClass('open-form');
});
$('.cont-form .close-cs').on('click',  function() {
  $('body').removeClass('open-form');
});
$('header .header-item').each(function(index) {
      $c_time = (index * 100) + 300;
      setTimeout(function(){
        $('header .header-item:nth-of-type('+(index+1)+')').addClass('f-an');
      }, $c_time );

});
$('.acc-tit').on('click', function(event) {
  if(!$(this).hasClass('active')){
    $(this).addClass('active')
    $(this).next('.acc-cont').slideDown();
    if ($(this).parents('.p-items')) {
      $(this).nextAll('.acc-tit').removeClass('active');
      $(this).prevAll('.acc-tit').removeClass('active');
      $(this).nextAll('.acc-tit').removeClass('open-i');
      $(this).prevAll('.acc-tit').removeClass('open-i');
      $(this).nextAll('.acc-tit').next('.acc-cont').slideUp();
      $(this).prevAll('.acc-tit').next('.acc-cont').slideUp();
    }
  }else{
    $(this).removeClass('active');
     $(this).removeClass('open-i');
    $(this).next('.acc-cont').slideUp();
  }
});


			setTimeout(function(){
				  $(window).trigger('scroll');
          $('body').addClass('page-ready');
			}, 100 );

	$('#menu-m').on('click',  function() {
	if(!$(this).hasClass('active')){
		$(this).addClass('active');
		$('body').addClass('mm-open');
		$('body').addClass('logo-show');
		$('header').addClass('scroll-h');
		$('#sherch-hg.active').trigger('click');
		$('#mc-cart-hg.active').trigger('click');
		//$('#close-log').trigger('click');


		$('nav > ul > div > li').each(function(index) {
			$c_time = (index * 100) + 300;
			setTimeout(function(){
				$('nav > ul > div > li:nth-of-type('+(index+1)+')').addClass('f-an');
			}, $c_time );
		});

	}else{
		$(this).removeClass('active');
		$('body').removeClass('mm-open');

		$('nav > ul > li').each(function(index) {
			$c_time = (index * 100);
			setTimeout(function(){
				$('nav > ul > li:nth-of-type('+(index+1)+')').removeClass('f-an');
			}, $c_time );
		});

	}
	});
  $('.cl-search').on('click',  function() {
    $('#sherch-hg.active').trigger('click');
     $('body').removeClass('s-open');
     $('html').removeClass('h-srcoll');

  });
  $('#sherch-hg').on('click',  function() {

    	if(!$(this).hasClass('active')){
        $(this).addClass('active');
        $('body').addClass('s-open');
         $('html').addClass('h-srcoll');
      }else{
        $(this).removeClass('active');
        $('body').removeClass('s-open');
         $('html').removeClass('h-srcoll');
      }
  });

  $('.f-btn').on('click',  function() {
    	if(!$(this).hasClass('active')){
        $(this).addClass('active');
        $('body').addClass('f-open');
      }else{
        $(this).removeClass('active');
        $('body').removeClass('f-open');
      }
  });

  $(document).on('click', '.hg-cl-f', function() {
    $('.f-btn.active').trigger('click');
  });

$('#view-th').on('click',  function() {
	if(!$(this).hasClass('active')){
		$(this).addClass('active');
		$(window).trigger('scroll');
		$(this).nextAll().removeClass('active');
		$(this).prevAll().removeClass('active');
		Cookies.set('shop-th', 'ok', { expires: 7 });
		Cookies.remove('shop-f');
		$('body').removeClass('shop-clm-f');
	}
});
$('#view-f').on('click',  function() {
	if(!$(this).hasClass('active')){
		$(window).trigger('scroll');
		$(this).addClass('active');
		$(this).nextAll().removeClass('active');
		$(this).prevAll().removeClass('active');
		Cookies.set('shop-f', 'ok', { expires: 7 });
		Cookies.remove('shop-th');
		$('body').addClass('shop-clm-f');
    $(window).trigger('scroll');
	}
});
if (Cookies.get('shop-th')) {
	$('body').removeClass('shop-clm-f');
		$('#view-th').addClass('active');
		$('#view-th').nextAll().removeClass('active');
		$('#view-th').prevAll().removeClass('active');
}
if (Cookies.get('shop-f')) {
	$('body').addClass('shop-clm-f');
		$('#view-f').addClass('active');
		$('#view-f').nextAll().removeClass('active');
		$('#view-f').prevAll().removeClass('active');
}




	$('nav .has-child').on('click',  function() {
	if(!$(this).hasClass('active')){
		$(this).addClass('active');
		$(this).next('.sub-nav').addClass('active');
    $fs_img = $(this).next('.sub-nav').find($('.hg-nav-items.has-img'));



    if ($fs_img){

       $('.sub-nav.active .menu-img').css('background-image', 'url('+$fs_img.attr("data-img")+')');
    }

   $(this).next('.sub-nav').find('li').each(function(index) {
			$c_time = (index * 50);
			setTimeout(function(){
				$('.sub-nav.active li:nth-of-type('+(index+1)+')').addClass('f-an');
			}, $c_time );
		});
	}
	});


	$('nav .sub-nav .bk-nav').on('click',  function() {
		$(this).parents('.sub-nav').removeClass('active');
		$(this).parents('.sub-nav').prev('.has-child').removeClass('active');
	});

if ($('#fs_logo svg').length > 0) {
  const $el = $('#fs_logo svg');
  const start = 0;
  const end = ($(window).height() / 2) + $el.height();

  $(window).on('scroll', function () {
    const scrollTop = $(this).scrollTop();

    if (scrollTop > end) {
      $('body').addClass('logo-show');
    } else {
      $('body').removeClass('logo-show');

      let progress = (scrollTop - start) / (end - start);
      progress = Math.min(Math.max(progress, 0), 1);

      const scale   = 1 - progress;
      const opacity = 1 - progress;

      $el.css({
        'transform': 'scale(' + scale + ')',
        'opacity':    opacity
      });
    }
  });
}
//slider

	$('.sl-nav .prev-i').on( 'click', function() {
		$(this).parents('.has-nav').find('.has-sl').flickity('previous');
	});

	$('.sl-nav .next-i').on( 'click', function() {
		$(this).parents('.has-nav').find('.has-sl').flickity('next');
	});
//slider
if($('[data-hg-products]').length > 0){
  $('[data-hg-products]').each(function () {
    var $section = $(this);
	if( $section.hasClass('s_swipe')){
    var $slider = $section.find('.has-sl');
    var $slides = $section.find('.hg-prod.sl');

    if ($slides.length === 0) return;

    var slideHeight = $slides.height();
    var currentSlide = 0;
    var maxSlides = $slides.length - 1;

    $section.css('height', $slides.length * slideHeight + 'px');

    var cur_p = $section.offset().top;

    $(window).on('scroll', function () {
      var scrollTop = $(this).scrollTop();
      var windowHeight = $(window).height();


      var blockBottom = cur_p + slideHeight;
      if (blockBottom > scrollTop + windowHeight) return;

      var nor_p = scrollTop - (cur_p + windowHeight + slideHeight);
      var targetSlide = Math.floor(nor_p / slideHeight);
      targetSlide = Math.min(Math.max(targetSlide, 0), maxSlides);

      if (targetSlide !== currentSlide) {
        currentSlide = targetSlide;
        $slider.flickity('select', currentSlide);
      }
    });
	}
  });
}
if($('.hg-prod .has-sl-sp').length > 0){
                  $('.hg-prod .has-sl-sp').each(function(){
                  if(!$(this).hasClass('.flickity-enabled')){
                                $(this).flickity({
                                cellAlign: "left" ,
                                pageDots: true,
                                prevNextButtons: false,
                                bgLazyLoad: true,
                                bgLazyLoad: 1,
                                wrapAround: true
                                });
                            }
                });
}


  //prod




    $('.var-attr').on('click',  function() {
    
    	if(!$(this).hasClass('active')){
        $(this).addClass('active');
        $('.variations').addClass('open');
        $('.variations').slideDown();
      }else{
        $(this).removeClass('active');
        $('.variations').slideUp();
        $('.variations').removeClass('open');
      }

  });
  $('.cl-v-btn').on('click',  function() {
       $('.var-attr.active').trigger('click');
  });
  
  $('.cs-size-var').on('click',  function() {
        $('body').addClass('cs-open');
  });

  $('.close-cs').on('click',  function() {
        $('body').removeClass('cs-open');
  });
  $('.close-mc').on('click',  function() {
        $('#mc-cart-hg.active').trigger('click');
  });


$('.t-btn').on('click',  function() {
	$('body').addClass('tp-open ');
	$cn_tab = $(this).attr('data-t');
	$('.t-nav[data-t='+$cn_tab+']').trigger('click');
});
$('.close-tp').on('click', function() {
	$('body').removeClass('tp-open');
});


$('.t-nav').on('click', function() {
	if (!$(this).hasClass('active')) {
		$(this).addClass('active');
		$(this).nextAll().removeClass('active');
		$(this).prevAll().removeClass('active');
		$c_tab = $(this).attr('data-t');
		$('.t-cont[data-t='+$c_tab+']').slideDown();
		$('.t-cont[data-t='+$c_tab+']').addClass('active');
		$('.t-cont[data-t='+$c_tab+']').nextAll().removeClass('active');
		$('.t-cont[data-t='+$c_tab+']').prevAll().removeClass('active');
		$('.t-cont[data-t='+$c_tab+']').nextAll().slideUp();
		$('.t-cont[data-t='+$c_tab+']').prevAll().slideUp();

	}

});
$('.show-colr').on('click',  function() {
  $('.color-grid').slideDown();
});
$('.cl-color').on('click',  function() {
  $('.color-grid').slideUp();
});
$('.variations .hg-i-fl').on('click', function() {
  $(this).addClass('active');
  $(this).nextAll().removeClass('active');
  $(this).prevAll().removeClass('active');
  $('body').removeClass('var-var')
  $cur_p = $(this).find('.for-var-price > div').clone();
  $('.prod-price-n').html($cur_p)
});
$('.cs-vals input').on('chnge', function() {
if($(this).vla() !== ''){
  $(this).removeClass('hg-unvalid');
 }else{
  $(this).addClass('hg-unvalid');
 }
});
  //prod
//cart
// === Рендер міні-кошика (нативний DOM, без jQuery) ===
function renderMiniCart(html) {
  var container = document.getElementById('m-cart-hg');
  var oldGrid = container.querySelector('.hg-cart-grid');
  if (oldGrid) oldGrid.remove();

  var temp = document.createElement('template');
  temp.innerHTML = html;
  var grid = temp.content.querySelector('.hg-cart-grid');

  if (grid) {
    container.appendChild(grid);
  } else {
    container.insertAdjacentHTML('beforeend', html);
    grid = container.querySelector('.hg-cart-grid');
  }

  var count = grid ? grid.getAttribute('data-cc-hg') : '0';
  container.classList.remove('loading-mc');

  var badge = document.querySelector('#mc-cart-hg #mc-qty');
  badge.classList.remove('hg-h');
  badge.textContent = count;

  if (count == 0) {
    container.classList.add('emp_car');
    document.getElementById('mc-cart-hg').classList.add('emp_c');
  } else {
    container.classList.remove('emp_car');
    document.getElementById('mc-cart-hg').classList.remove('emp_c');
  }
}

// === Завантажити міні-кошик (тільки для відкриття по кліку) ===
function updateMiniCart() {
  return fetch('/cart?sections=mini-cart')
    .then(function(res) { return res.json(); })
    .then(function(data) {
      renderMiniCart(data['mini-cart']);
      $('#m-cart-hg').removeClass('loading-mc');
    });
}

// === Змінити кількість (один запит + оптимістичне оновлення) ===
function changeCartItem(line, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      line: parseInt(line),
      quantity: quantity,
      sections: 'mini-cart'
    })
  })
  .then(function(res) { return res.json(); })
  .then(function(data) {
    renderMiniCart(data.sections['mini-cart']);
     $('#m-cart-hg').removeClass('loading-mc');
  });
}

// === Клік на іконку кошика ===
$('#mc-cart-hg').on('click', function() {
  if (!$(this).hasClass('active')) {
    $('body').addClass('mc-open');
    $(this).addClass('active');
    if (!$(this).hasClass('emp_c')) {
      //$('#m-cart-hg').addClass('loading-mc');
      //$('#m-cart-hg .hg-cart-grid').remove();
      //updateMiniCart();
    }else{
      //updateMiniCart();
    }
  } else {
    $(this).removeClass('active');
    $('body').removeClass('mc-open');
  }
});

$('.close-cs').on('click', function() {
  $('#mc-cart-hg.active').trigger('click');
});

// === Видалити товар (одразу прибираємо з UI) ===
$(document).on('click', '.cart-item__remove', function() {
  $('#m-cart-hg').addClass('loading-mc');
  var line = $(this).attr('data-line');
  $(this).closest('.cart-item').fadeOut(150, function() { $(this).remove(); });
   $('#m-cart-hg').addClass('loading-mc');
  changeCartItem(line, 0);
});

// === Мінус (одразу оновлюємо цифру) ===
$(document).on('click', '.cart-item__minus', function() {
  $('#m-cart-hg').addClass('loading-mc');
  var line = $(this).attr('data-line');
  var input = $(this).siblings('.cart-item__qty-input');
  var qty = parseInt(input.val()) - 1;
  if (qty < 1) {
    $(this).closest('.cart-item').fadeOut(150, function() { $(this).remove(); });
    changeCartItem(line, 0);
  } else {
    input.val(qty);
    changeCartItem(line, qty);
     
  }
});

// === Плюс (одразу оновлюємо цифру) ===
$(document).on('click', '.cart-item__plus', function() {
   $('#m-cart-hg').addClass('loading-mc');
  var line = $(this).attr('data-line');
  var input = $(this).siblings('.cart-item__qty-input');
  var qty = parseInt(input.val()) + 1;
  input.val(qty);
  changeCartItem(line, qty);
  
});

// === Ручна зміна інпуту ===
$(document).on('change', '.cart-item__qty-input', function() {
  $('#m-cart-hg').addClass('loading-mc');
  var line = $(this).attr('data-line');
  var qty = parseInt($(this).val());
  if (qty < 1) qty = 1;
  changeCartItem(line, qty);
   
});

//custom p
$('.sp-item').on('click',  function() {
if (!$(this).hasClass('active')) {
  $c_in = $(this).parent('.f-wr').find('input');
  $(this).addClass('active');
  $c_in.val($(this).attr('d-val'));
  $(this).nextAll().removeClass('active');
  $(this).prevAll().removeClass('active');
}
});
//custom p
$('.hg-add-cart').on('click', function() {

  var btn = $(this);
  if ($('.variations .hg-i-fl').length > 0) {
  if($('.variations .hg-i-fl').length == 1 && !$('.variations .hg-i-fl').hasClass('active')){
     $('.variations .hg-i-fl').trigger('click');
  }
     var variantId = $('.variations .hg-i-fl.active').attr('data-id');
  }else{
    variantId = btn.attr('data-variant-id');
  }

  if (!variantId) {
    if(!$('.prod-tpl').hasClass('show-des') && !$('.var-attr').hasClass('active')){
        $('.var-attr').trigger('click');
    }
    $('body').addClass('var-var');
    return;

  }

  
  var properties = {};
  var dateVal = $('#p-date').val();
  if (dateVal) properties['Delivery date'] = dateVal;
  var noteVal = $('#p-none').val();
  if (noteVal) properties['Note'] = noteVal;

  var packId = parseInt($('#pack').val());
  var cardId = parseInt($('#c-card').val());
  var extraItems = [];
  if (packId) extraItems.push({ id: packId, quantity: 1 });
  if (cardId) extraItems.push({ id: cardId, quantity: 1 });
  console.log(extraItems);
  var body;
  if (extraItems.length > 0) {
    body = { items: extraItems.concat([{ id: parseInt(variantId), quantity: 1, properties: properties }]), sections: 'mini-cart' };
  } else {
    body = { id: parseInt(variantId), quantity: 1, properties: properties, sections: 'mini-cart' };
  }

  btn.addClass('loading');
fetch('/cart/add.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(body)
})
.then(function(res) { return res.json(); })
.then(function(data) {
  renderMiniCart(data.sections['mini-cart']);
  if (!$('#mc-cart-hg').hasClass('active')) {
    $('#mc-cart-hg').trigger('click');
    $('body').removeClass('cs-open');
  }
})
  .catch(function(err) { console.error(err); })
  .finally(function() {
  btn.removeClass('loading');
  });
});




//cart
});
// ── Ініціалізація гріду (запускається і при завантаженні, і після фільтрів) ──
function hgInitGrid() {
  var isMob = $(window).width() <= 1000;

  // Lazy bg images (статичні, вже в DOM)
  $('#ProductGridContainer .hg-ll-img-st').each(function() {
    var src = isMob ? ($(this).attr('data-m-i') || $(this).attr('data-p-i')) : $(this).attr('data-p-i');
    if (src) $(this).css('background-image', 'url(' + src + ')');
  });

          $('#ProductGridContainer .hg-ll-img-st-sl').each(function() {
            if ($(window).width() > 1000 ) {
              $lod_i = $(this).attr('data-p-i');
            }else{
              $lod_i = $(this).attr('data-p-i');
            }
            if ($(this).attr('data-flickity-bg-lazyload') == ''){
            $(this).attr('data-flickity-bg-lazyload',$lod_i);
            }
          });
  // Flickity на картках продуктів
  $('#ProductGridContainer .has-sl-sp').each(function() {
    if (!$(this).hasClass('flickity-enabled')) {
      $(this).flickity({
        cellAlign: 'left',
        pageDots: true,
        prevNextButtons: false,
        bgLazyLoad: 1,
        wrapAround: true
      });
    }
  });

  // Тригеримо scroll щоб підхопились .hg-ll-img та анімації
  $(window).trigger('scroll');
}

document.addEventListener('hg:grid:updated', function() {
  hgInitGrid();
});

//form sub
document.addEventListener('submit', function (e) {
  var form = e.target.closest('.footer__newsletter');
  if (!form) return;
  e.preventDefault();
  e.stopPropagation();

  var input = form.querySelector('input[type="email"]');
  var originalPlaceholder = input.getAttribute('placeholder');
  var email = input.value.trim();

  if (!email) return;

  fetch('/contact', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: new URLSearchParams(new FormData(form)).toString(),
  })
  .then(function(res) {
    // Shopify повертає редірект або HTML — перевіряємо URL відповіді
    if (res.redirected && res.url.includes('challenge')) {
      // Потрапили на капчу — показуємо помилку
      input.setAttribute('placeholder', 'Спробуйте ще раз пізніше');
    } else {
      input.value = '';
      input.setAttribute('placeholder', 'Дякуємо за підписку!');
    }
    setTimeout(function () {
      input.setAttribute('placeholder', originalPlaceholder);
    }, 4000);
  })
  .catch(function() {
    input.setAttribute('placeholder', 'Помилка. Спробуйте ще раз.');
    setTimeout(function () {
      input.setAttribute('placeholder', originalPlaceholder);
    }, 4000);
  });
}, true);

document.addEventListener('submit', function(e) {
  var form = e.target.closest('#ContactForm');
  if (!form) return;
  e.preventDefault();
  e.stopPropagation();

  fetch(form.action, {
    method: 'POST',
    body: new FormData(form),
  })
  .then(function(res) {
    if (res.redirected && res.url.includes('challenge')) {
      $('#ContactForm-error').show();
    } else {
      form.reset();
      $('#ContactForm-success').show();
    }
  })
  .catch(function() {
    $('#ContactForm-error').show();
  });
}, true);
